import { BaseModal } from "../BaseModal";
import clsx from "clsx";
import "./AddNewModal.scss";
import { ReactNode } from "react";
import { AddNewModalHeader } from "@/components/ui/AddNewModal/AddNewModalHeader";
import { AddNewModalContent } from "@/components/ui/AddNewModal/AddNewModalContent";
import { AddNewModalFooter } from "@/components/ui/AddNewModal/AddNewModalFooter";

type AddNewModalProps = {
  open: boolean;
  overrideClassNames?: string;
  setOpen: (open: boolean) => void;
  children: ReactNode;
  role?: "dialog" | "alertdialog";
};

const AddNewModal = ({
  open,
  overrideClassNames,
  setOpen,
  children,
  role = "dialog",
}: AddNewModalProps) => {
  return (
    <BaseModal
      open={open}
      setOpen={setOpen}
      overrideClassNames={clsx("ui-add-new-modal-override", overrideClassNames)}
      role={role}
    >
      {children}
    </BaseModal>
  );
};

AddNewModal.Header = AddNewModalHeader;
AddNewModal.Content = AddNewModalContent;
AddNewModal.Footer = AddNewModalFooter;

export { AddNewModal };
